import { Ciclo, Plano, PLANOS, valorCobranca } from '@/utils/planos';
import { cn } from '@/utils/cn';

const reais = (v: number) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });

// Desconto do anual sobre 12 mensalidades (igual nos três planos: ~17%)
export const DESCONTO_ANUAL = Math.round((1 - PLANOS.CORRETORA.mensalNoAnual / PLANOS.CORRETORA.mensal) * 100);

// Escolha de plano e ciclo (cadastro e assinatura): lista de planos com preço por mês e seletor Mensal/Anual
export const SeletorPlano = ({ plano, ciclo, onChange, titulo = 'Escolha o plano', atual }: {
  plano: Plano;
  ciclo: Ciclo;
  onChange(plano: Plano, ciclo: Ciclo): void;
  titulo?: string;
  atual?: { plano?: Plano; ciclo?: Ciclo };   // marca o plano contratado
}) => (
  <fieldset>
    <div className="mb-3 flex items-center justify-between gap-4">
      <legend className="text-sm font-semibold">{titulo}</legend>
      <div className="inline-flex rounded-full bg-muted p-1 text-sm" role="group" aria-label="Forma de cobrança">
        {(['MENSAL', 'ANUAL'] as Ciclo[]).map(c => (
          <button key={c} type="button" onClick={() => onChange(plano, c)} aria-pressed={ciclo === c}
            className={cn('rounded-full px-3.5 py-1.5 font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
              ciclo === c ? 'bg-background text-primary shadow-sm' : 'text-muted-foreground hover:text-foreground')}>
            {c === 'MENSAL' ? 'Mensal' : <>Anual <span className="ml-1 rounded-full bg-[#2BB673]/15 px-1.5 py-0.5 text-[11px] font-semibold text-[#1f8f57] dark:text-[#5fd39b]">-{DESCONTO_ANUAL}%</span></>}
          </button>
        ))}
      </div>
    </div>
    <div className="space-y-2.5" role="radiogroup" aria-label="Plano">
      {(Object.keys(PLANOS) as Plano[]).map(p => {
        const ativo = plano === p;
        const contratado = atual?.plano === p && atual?.ciclo === ciclo;
        const porMes = ciclo === 'ANUAL' ? PLANOS[p].mensalNoAnual : PLANOS[p].mensal;
        return (
          <button key={p} type="button" role="radio" aria-checked={ativo} onClick={() => onChange(p, ciclo)}
            className={cn('flex w-full items-center gap-4 rounded-xl border px-4 py-3.5 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
              ativo ? 'border-[#2BB673] bg-[#2BB673]/[0.06] ring-1 ring-[#2BB673]' : 'border-border hover:border-muted-foreground/40')}>
            <span className={cn('flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2', ativo ? 'border-[#2BB673]' : 'border-muted-foreground/40')}>
              {ativo && <span className="h-2.5 w-2.5 rounded-full bg-[#2BB673]" />}
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex flex-wrap items-center gap-x-2 gap-y-1 font-semibold">
                {PLANOS[p].nome}
                {contratado
                  ? <span className="whitespace-nowrap rounded-full bg-muted px-2 py-0.5 text-[11px] font-semibold text-muted-foreground">Plano atual</span>
                  : p === 'CORRETORA' && <span className="whitespace-nowrap rounded-full bg-primary px-2 py-0.5 text-[11px] font-semibold text-primary-foreground">Mais escolhido</span>}
              </span>
              <span className="block text-sm text-muted-foreground">
                {PLANOS[p].usuarios === 1 ? '1 usuário' : `Até ${PLANOS[p].usuarios} usuários`}
              </span>
            </span>
            <span className="shrink-0 text-right">
              <span className="block font-bold">{reais(porMes)}<span className="text-sm font-normal text-muted-foreground">/mês</span></span>
              {ciclo === 'ANUAL' && <span className="block text-xs text-muted-foreground">{reais(valorCobranca(p, ciclo))} por ano</span>}
            </span>
          </button>
        );
      })}
    </div>
  </fieldset>
);
